import type { GenericObject } from '@makemydeal/dr-platform-types';
import type { GridPaymentGridData, GridWrittenHalves } from '../types/paymentTypes';

export const GRID_RATE_KEYS = ['sellRate', 'buyRate', 'rateType'] as const;
export const GRID_RESIDUAL_KEYS = [
    'programResidual',
    'programResidualPercent',
    'baseResidualAmount',
    'baseResidualPercent',
    'baseResidualType'
] as const;

export const pickGridWrittenOverrides = (
    termOverrides: GenericObject | undefined,
    halves: GridWrittenHalves | undefined
): GenericObject | undefined => {
    if (!termOverrides || !halves) return undefined;

    const picked: GenericObject = {};
    if (halves.rate) {
        GRID_RATE_KEYS.forEach((rateKey) => {
            if (termOverrides[rateKey] !== undefined) picked[rateKey] = termOverrides[rateKey];
        });
    }
    if (halves.residual && termOverrides.residualInfo) picked.residualInfo = termOverrides.residualInfo;

    return Object.keys(picked).length ? picked : undefined;
};

export const overridesTypedInGrid = (
    gridData: GridPaymentGridData | undefined,
    dealTermMonths: number | undefined
): Record<number, GridWrittenHalves> => {
    const typedHalves: Record<number, GridWrittenHalves> = {};
    const mark = (termMonths: number | null | undefined, halves: GridWrittenHalves) => {
        if (termMonths == null || termMonths === dealTermMonths) return;
        typedHalves[termMonths] = { ...typedHalves[termMonths], ...halves };
    };

    Object.entries(gridData?.columnOverrides ?? {}).forEach(([columnIndex, entry]) => {
        const termMonths = entry.term ?? gridData?.terms?.[Number(columnIndex)];
        if (entry.sellRate != null) mark(termMonths, { rate: true });
        if (entry.residualInfo != null) mark(termMonths, { residual: true });
    });
    Object.values(gridData?.leftTermsByTerm ?? {})
        .flat()
        .forEach((termMonths) => mark(termMonths, { rate: true, residual: true }));

    return typedHalves;
};
